export const initializeQaSurface = (route: string, mode: string) => {
  window.__PARADOX_QA__ = {
    route,
    mode,
    events: window.__PARADOX_QA__?.events ?? [],
    passportStampedStops: window.__PARADOX_QA__?.passportStampedStops ?? [],
    sponsorInstances: document.querySelectorAll('[data-presenter-lockup]').length,
    externalRuntimeRequests: [],
  }
}

export const updateQaSurface = (patch: Partial<ParadoxQaSurface>) => {
  if (!window.__PARADOX_QA__) initializeQaSurface(window.location.pathname, 'caution-roster-product')
  if (window.__PARADOX_QA__) Object.assign(window.__PARADOX_QA__, patch)
}

export const recordLocalEvent = (name: string, detail?: string) => {
  if (!window.__PARADOX_QA__) initializeQaSurface(window.location.pathname, 'caution-roster-product')
  window.__PARADOX_QA__?.events.push({
    name,
    at: new Date().toISOString(),
    ...(detail ? { detail } : {}),
  })
}
